import React, { useContext, useEffect } from "react";
// router, intl
import { useIntl } from "react-intl";
import { useNavigate } from "react-router";
// ui
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import classNames from "classnames";
// component
import NodeColorAdjust from "./nodeColor/NodeColorAdjust";
import LinkColorAdjust from "./linkColor/LinkColorAdjust";
import NodePlacementAdjust from "./nodePlacement/NodePlacementAdjust";
import NodeDispersionAdjust from "./nodeDispersion/NodeDispersionAdjust";
import NodeShowCountAdjust from "./nodeShowCount/NodeShowCountAdjust";
import LegendShowNoDataGroup from "./legendShowNoDataGroup/LegendShowNoDataGroup";
import BottomPanel from "./bottomPanel/BottomPanel";
import { StoreContext } from "../../../../../store/StoreProvider";
// hook
import useModulePublic from "../../../../hooks/useModulePublic";
import useLocaleRoute from "../../../../../common/hooks/useLocaleRoute";
// config, utils
import urls from "../../../../../api/project/ApiUrls";
import fireAuth from "../../../../../api/firebase/auth/utils";
import { NODE_PLACE_MODE } from "./nodePlacement/option";

const AdjustTool = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  //
  const [state, dispatch] = useContext(StoreContext);
  const { user, sna } = state;
  const { locale } = user;
  const { adjust } = sna;
  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();
  //
  const isLoggedIn = fireAuth.isLoggedIn(user);
  // const isLoggedIn = true;

  //
  const handleDisabled = (moduleId) => !handlePublic(moduleId);

  const handleShowDispersion =
    adjust?.nodePlaceMode?.change === NODE_PLACE_MODE.centerAndEdge;

  return (
    <Box sx={{ overflow: "auto" }}>
      <Box pb={2}>
        <Typography
          textAlign="left"
          variant="body1"
          sx={{
            color: "#fff",
          }}
          className={classNames(
            "sna-sidebar__title",
            "sna-sidebar__title--adjust-tool"
          )}
        >
          {intl.formatMessage({
            id: "sna.sidebar.adjusttool.title",
            defaultMessage: "外觀",
          })}
        </Typography>
      </Box>
      <NodeColorAdjust />
      <LinkColorAdjust />
      <NodePlacementAdjust />
      {handleShowDispersion && <NodeDispersionAdjust />}
      <NodeShowCountAdjust />
      <LegendShowNoDataGroup />
      <BottomPanel />
    </Box>
  );
};

export default AdjustTool;
